module.exports = __webpack_public_path__ + "img/Pic_TB_F.e1bfcdb1.png";